import { useState } from "react";
import { toast } from "sonner";
import { Field, PageHeader, PrimaryBtn, inputCls } from "@/components/Common";
import { WHATSAPP, errMsg, http } from "@/lib/api";

const POLICIES = {
  terms: ["Terms & conditions", [
    "Bookings are confirmed only after full payment is received and a booking reference is issued by NextVisionSolutions.",
    "Prices are quoted in Indian Rupees (₹) and include applicable taxes unless stated otherwise. Fares may change until payment is completed.",
    "Travellers are responsible for valid ID, passports, visas and health documents required for their journey.",
    "Itineraries may be altered due to weather, local regulations or operational reasons; equivalent alternatives will be offered.",
    "Disputes are subject to the jurisdiction of courts in India.",
  ]],
  privacy: ["Privacy policy", [
    "We collect your name, email, phone number and travel details only to process bookings and provide customer support.",
    "Payments are processed by Razorpay; we never store your card, UPI or banking credentials.",
    "Your data is shared only with the airlines, hotels and transport partners needed to fulfil your booking.",
    "You can request access to or deletion of your data by writing to nextvisionsolutions@rediffmail.com.",
  ]],
  refund: ["Cancellation & refund policy", [
    "Flights: refunds follow the airline's fare rules; a service fee of ₹300 per passenger applies.",
    "Hotels: free cancellation up to 48 hours before check-in where marked; non-refundable rates are not refunded.",
    "Taxi: free cancellation up to 6 hours before pickup; 25% of the fare is charged thereafter.",
    "Holiday packages: 30+ days before travel – 90% refund; 15–29 days – 50%; under 15 days – no refund.",
    "Approved refunds are credited to the original payment method within 5–7 working days.",
  ]],
};

export const Policy = ({ kind }) => {
  const [title, items] = POLICIES[kind];
  return (
    <div data-testid={`policy-${kind}`}>
      <PageHeader eyebrow="NextVisionSolutions" title={title} />
      <ol className="mx-auto max-w-3xl list-decimal space-y-4 px-8 py-14 text-slate-700 leading-relaxed">
        {items.map((t) => <li key={t}>{t}</li>)}
      </ol>
    </div>
  );
};

export const Contact = () => {
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/contact", f);
      toast.success("Thanks! Our travel expert will get back to you shortly.");
      setF({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact" title="Talk to a travel expert." sub="Custom group tours, honeymoons, corporate travel — write to us and we'll plan it." />
      <div className="mx-auto grid max-w-5xl gap-10 px-4 py-14 sm:px-8 md:grid-cols-2">
        <div className="space-y-3 text-slate-700">
          <p><b>Email:</b> nextvisionsolutions@rediffmail.com</p>
          <p><b>WhatsApp / Call:</b> <a href={WHATSAPP.link} target="_blank" rel="noreferrer" className="text-[#128C7E] font-semibold underline" data-testid="contact-whatsapp">{WHATSAPP.display}</a></p>
          <p><b>Hours:</b> Monday–Saturday, 9am–8pm IST</p>
          <p><b>Based in:</b> India</p>
        </div>
        <form onSubmit={submit} className="space-y-3 rounded-2xl border border-[#E5E0D8] bg-white p-6">
          <Field label="Name"><input required minLength={2} className={inputCls} value={f.name} onChange={set("name")} data-testid="contact-name-input" /></Field>
          <Field label="Email"><input required type="email" className={inputCls} value={f.email} onChange={set("email")} data-testid="contact-email-input" /></Field>
          <Field label="Phone"><input className={inputCls} value={f.phone} onChange={set("phone")} data-testid="contact-phone-input" /></Field>
          <Field label="Message"><textarea required minLength={5} rows={4} className={`${inputCls} h-auto py-2`} value={f.message} onChange={set("message")} data-testid="contact-message-input" /></Field>
          <PrimaryBtn type="submit" disabled={busy} className="w-full" data-testid="contact-submit-btn">Send enquiry</PrimaryBtn>
        </form>
      </div>
    </div>
  );
};
